import React, { useRef, useEffect } from 'react';

import { InputRadioStyled } from './styles';

import { InputRadioProps } from './types';

export const InputRadio = ({ indeterminate, ...props }: InputRadioProps & { indeterminate?: boolean }): JSX.Element => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = indeterminate ?? false;
    }
  }, [indeterminate]);

  return <InputRadioStyled ref={ref} type={'radio'} {...props} />;
};
